var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHomeCopyBet = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.88486 16H7.11514C4.3579 16 2.97927 16 2.03922 15.1905C1.09917 14.3811 0.904204 13.0261 0.51427 10.3162L0.291258 8.76629C-0.0122978 6.65665 -0.164076 5.60183 0.268293 4.69996C0.700662 3.79808 1.62095 3.24987 3.46153 2.15345L4.5694 1.4935C6.24083 0.497832 7.07655 0 8 0C8.92345 0 9.75917 0.497832 11.4306 1.4935L12.5385 2.15345C14.379 3.24987 15.2993 3.79808 15.7317 4.69996C16.1641 5.60183 16.0123 6.65665 15.7087 8.7663L15.4857 10.3162C15.0958 13.0261 14.9008 14.3811 13.9608 15.1905C13.0207 16 11.6421 16 8.88486 16ZM5.11806 10.8425C5.31539 10.5763 5.69116 10.5205 5.95737 10.7178C6.54004 11.1497 7.24336 11.3998 8.00008 11.3998C8.7568 11.3998 9.46012 11.1497 10.0428 10.7178C10.309 10.5205 10.6848 10.5763 10.8821 10.8425C11.0794 11.1088 11.0236 11.4845 10.7574 11.6819C9.97944 12.2585 9.02806 12.5998 8.00008 12.5998C6.9721 12.5998 6.02072 12.2585 5.24279 11.6819C4.97658 11.4845 4.92073 11.1088 5.11806 10.8425Z",
    fill: "url(#paint0_linear_4238_5463)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4238_5463",
    x1: 0,
    y1: 0,
    x2: 16,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EFF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#199E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#107300"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHomeCopyBet, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/HomeCopyBet.4d040402.svg";
export { ForwardRef as ReactComponent };